const SubscriptionHeader = ({ billingInterval, setBillingInterval }) => {
  return (
    <section className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
          Plans that grow with you
        </h1>
        <p className="mt-2 max-w-2xl text-sm sm:text-base leading-6 text-slate-500">
          Choose the plan that suits your business today. Upgrade whenever you are ready for more.
        </p>
      </div>

      {/* Clean Segmented Pill Toggle */}
      <div className="self-start md:self-auto inline-flex items-center p-1 bg-slate-100 rounded-full border border-slate-200 shadow-2xs">
        <button
          type="button"
          onClick={() => setBillingInterval('month')}
          className={`px-5 py-2 rounded-full text-xs font-semibold transition-all duration-200 cursor-pointer ${
            billingInterval === 'month'
              ? 'bg-white text-[#067978] shadow-xs'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          Monthly billing
        </button>
        <button
          type="button"
          onClick={() => setBillingInterval('year')}
          className={`px-5 py-2 rounded-full text-xs font-semibold transition-all duration-200 cursor-pointer ${
            billingInterval === 'year'
              ? 'bg-[#067978] text-white shadow-xs'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          Annual billing
        </button>
      </div>
    </section>
  );
};

export default SubscriptionHeader;
